module.exports = __webpack_public_path__ + "img/1.1ada7fd7.jpg";